import styled from "@emotion/styled";
import { DialogActions, Flex, Typography } from "@ugc-ui/lego";

export const StyledFlex = styled(Flex)`
  justify-content: center;
`;

export const StyledHref = styled("a")<{ fullScreen: boolean }>`
  text-decoration: none;
  margin: 8px 0;
  max-width: 400px;
  min-width: 220px;
  width: 90%;
`;

export const StyledFlexButtons = styled(Flex)<{ fullScreen: boolean }>`
  align-items: center;
  width: 100%;
  justify-content: center;
  flex-direction: ${({ fullScreen }) => (fullScreen ? "column" : "row")}};
`;

export const TypographyStyled = styled(Typography)`
  color: white;
  text-align: center;
`;

export const MessageText = styled(Typography)`
  text-align: center;
`;

export const DialogActionsStyled = styled(DialogActions)`
  display: flex;
  justify-content: center;
`;
